const UploadSelfie = async (selfieFanData) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + 'selfiefan/upload',
        {
            method: 'POST',
            headers: {
                'Content-Type': selfieFanData.blob.type || 'application/octet-stream',
                'X-Caption': selfieFanData.caption || '',
                "X-Source": selfieFanData.source || "",
            },
            body: selfieFanData.blob
        })
        
        if (!response.ok) {
            let errorMessage = 'No ha sido posible subir la foto. Inténtalo nuevamente o inténtalo más tarde.'
            const err = await response.json()
            errorMessage = err.message || errorMessage
            return { success: false, message: errorMessage }
        }
        
        const data = await response.json()
        
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Hubo un error al intentar subir la foto. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const GetAllMetadataSelfies = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + 'selfiefan',
        {
            method: 'GET'//,
            // headers: {
            //     'Content-Type': 'application/json',
            // }
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible obtener el listado de metadatos de las fotos. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const data = await response.json()
        
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar obtener el listado de metadatos de las fotos. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const GetAllSelfies = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + 'selfiefan/getAll',
        {
            method: 'GET'//,
            // headers: {
            //     'Content-Type': 'application/json',
            // }
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible obtener el listado de fotos. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const data = await response.json()
        
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar obtener el listado de fotos. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const GetSelfieById = async (id) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefan/${id}/content`,
        {
            method: 'GET'//,
            // headers: {
            //     'Content-Type': 'application/json',
            // }
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible obtener la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const data = await response.json()
        
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar obtener la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const SelectSelfie = async (selfieId) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefan/${selfieId}/select`,
        {
            method: 'POST'
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible seleccionar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar seleccionar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeselectSelfie = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefan/selected/clear`,
        {
            method: 'POST'
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible deseleccionar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar deseleccionar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeleteSelfie = async (selfieId) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefan/${selfieId}`,
        {
            method: 'DELETE'
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible eliminar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar eliminar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const GetSelfieSelected = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefan/selected/content`,
        {
            method: 'GET'//,
            // headers: {
            //     'Content-Type': 'application/json',
            // }
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible obtener la foto seleccionada. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const data = await response.json()
        
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar obtener la foto seleccionada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const ResetDinamyc = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefan/reset`,
        {
            method: 'POST'//,
            // headers: {
            //     'Content-Type': 'application/json',
            // }
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible reiniciar la dinámica. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const data = await response.json()
        
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar reiniciar la dinámica. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

/**
 * DL: Descarga una página ligera de selfies.
 * Endpoint: GET /api/selfiefan/list?source=...&limit=...&cursor=...
 *
 * @param {Object} args
 * @param {"selfie_fan"|"selfie_ia"|null} args.source  Filtro por origen (opcional)
 * @param {number} args.limit                           Tamaño de página (1..100). Default 30
 * @param {string|null} args.cursor                     Cursor de la página siguiente (opcional)
 * @returns {Promise<{success:boolean, data?: { items: Array, nextCursor: string|null }, message?: string}>}
 */
const GetSelfiesPage = async ({ source = null, limit = 30, cursor = null } = {}) => {
  try {
        const params = new URLSearchParams()
        if (source) params.set("source", source)
        if (limit) params.set("limit", String(limit))
        if (cursor) params.set("cursor", cursor)

        const url = `${process.env.REACT_APP_API_URL}selfiefan/list?${params.toString()}`
        
        const response = await fetch(url, {
            method: "GET",
            headers: { "Accept": "application/json" },
        })
        
        if (!response.ok) {
        //   const err = await safeJson(res)
        //   const msg = err?.message || "No se pudo obtener el listado."
        //   return { success: false, message: msg }
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible obtener las fotos. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const data = await response.json()
        // data => { items:[{id,source,caption,contentType,createdAtUtc,isSelected,thumbUrl,contentUrl}], nextCursor:string|null }
        
        return { success: true, data: data }
  } catch (e) {
    return { success: false, message: "Error de red al obtener el listado." }
  }
}

const SendSelfiesFanIAToScreen = async (selfiesData) => {
    try {
        if (!selfiesData || selfiesData?.length === 0) {
            return { success: false, message: '' }
        }

        const dataToSend = []

        selfiesData.forEach(selfie => {
            let selfieData = {
                id: selfie.id,
                animation: selfie.animation
            }
            dataToSend.push(selfieData)
        })
        
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefania/select`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible enviar la Selfie Fan IA deseada. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar enviar la Selfie Fan IA deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeselectSelfieFanIA = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefania/clear`,
        {
            method: 'POST'
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible deseleccionar la Selfie Fan IA deseada. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar deseleccionar la Selfie Fan IA deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const SendSelfiesFanMosaicToScreen = async (selfiesData) => {
    try {
        if (!selfiesData || selfiesData?.length === 0) {
            return { success: false, message: '' }
        }

        const dataToSend = []

        selfiesData.forEach(selfie => {
            let selfieData = {
                id: selfie.id,
                animation: selfie.animation
            }
            dataToSend.push(selfieData)
        })
        
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefania/mosaic/select`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible enviar la Selfie Fan Mosaic deseada. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar enviar la Selfie Fan Mosaic deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeselectSelfieFanMosaic = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `selfiefania/mosaic/clear`,
        {
            method: 'POST'
        })
        
        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible deseleccionar la Selfie Fan Mosaic deseada. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar deseleccionar la Selfie Fan Mosaic deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

/**
 * ============================================================================
 * NUEVAS FUNCIONES: OVERLAY Y CÓDIGO QR
 * ============================================================================
 */

const SendOverlayConfig = async (offsetX, offsetY, scale) => {
    try {
        // BLINDAJE: Aseguramos que X e Y sean enteros estrictos, y Scale sea número.
        const safeX = Math.round(offsetX || 0);
        const safeY = Math.round(offsetY || 0);
        // Scale sí puede llevar decimales porque en C# lo declaramos como "double"
        const safeScale = parseFloat(scale) || 1.0;

        // Como los parámetros van por [FromQuery], los concatenamos en la URL
        const response = await fetch(`${process.env.REACT_APP_API_URL}selfiefan/overlay-config?offsetX=${safeX}&offsetY=${safeY}&scale=${safeScale}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al actualizar el Overlay' };
        }

        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

// const SendQRToOverlay = async () => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}SelfieFan/overlay-qr`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' }
//         })

//         if (!response.ok) {
//             const err = await response.json();
//             return { success: false, message: err.message || 'No ha sido posible enviar la señal para mostrar el QR en pantalla. Inténtalo nuevamente o inténtalo más tarde' };
//         }

//         return { success: response.ok, data: null }
//     } catch (error) {
//         return { success: false, message: "Error de conexión." }
//     }
// };

/**
 * Obtiene la configuración guardada del Overlay (Posición y Escala) desde la Base de Datos.
 */
const GetOverlaySettings = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SelfieFan/overlay-settings`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) {
            return { success: false, message: 'Error al obtener la configuración del overlay.' };
        }

        const data = await response.json();
        return data; // Retorna { success: true, data: { x, y, scale, lastSavedAt } }
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

/**
 * Guarda la configuración del Overlay (Posición y Escala) en la Base de Datos.
 * @param {Object} payload - Objeto con { x, y, scale }
 */
const SaveOverlaySettings = async (payload) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SelfieFan/overlay-settings`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'Error al guardar la configuración.' };
        }

        const data = await response.json();
        return data; // Retorna { success: true, message: "..." }
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

/**
 * Envía la señal al Overlay (OBS) para que muestre el Código QR.
 */
const SendQRToOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SelfieFan/overlay-qr`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) {
            return { success: false, message: 'Error al enviar el comando del QR.' };
        }

        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

/**
 * Envía la señal al Overlay (OBS) para que muestre el Código QR de mensajes. MOVER A MENSAJES O MESSAGES
 */
const SendMessagesQRToOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}messages/overlay-qr`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!response.ok) {
            return { success: false, message: 'Error al enviar el comando del QR.' };
        }
        
        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

/**
 * Envía la imagen capturada por el Staff al endpoint seguro.
 * * @param {Object} staffImageData - Contiene el blob de la imagen y opcionalmente un mensaje.
 * @param {Blob} staffImageData.imageBlob - El archivo físico de la imagen.
 * @param {string} staffImageData.imageCaption - Mensaje opcional adjunto a la foto.
 * @returns {Promise<Object>} Resultado estandarizado { success, data/message }
 */
const UploadStaffSelfieImage = async (staffImageData) => {
    try {
        const responseFromServer = await fetch(`${process.env.REACT_APP_API_URL}selfiefan/staff/upload`, {
            method: 'POST',
            headers: {
                'Content-Type': staffImageData.imageBlob.type || 'application/octet-stream',
                'X-Caption': staffImageData.imageCaption || '',
                // No enviamos X-Source porque el Backend lo sobrescribe por seguridad
            },
            body: staffImageData.imageBlob
        });
        
        if (!responseFromServer.ok) {
            const errorPayload = await responseFromServer.json();
            return { 
                success: false, 
                message: errorPayload.message || 'Error en el servidor al intentar subir la foto del Staff.' 
            };
        }
        
        const successData = await responseFromServer.json();
        return { success: true, data: successData };

    } catch (networkError) {
        console.error("UploadStaffSelfieImageDL -> Error de red:", networkError);
        return { 
            success: false, 
            message: 'Hubo un error de conexión al intentar subir la foto del Staff.' 
        };
    }
};

export { UploadSelfie, GetAllMetadataSelfies, GetAllSelfies, GetSelfieById, SelectSelfie, DeselectSelfie, DeleteSelfie, GetSelfieSelected, ResetDinamyc, GetSelfiesPage, SendSelfiesFanIAToScreen, DeselectSelfieFanIA, SendSelfiesFanMosaicToScreen, DeselectSelfieFanMosaic, SendOverlayConfig, GetOverlaySettings, SaveOverlaySettings, SendQRToOverlay, SendMessagesQRToOverlay, UploadStaffSelfieImage };















// /**
//  * Llama a la API y sube la selfie.
//  * No crea archivos en disco, envía el Blob como stream.
//  * 
//  * @param {{
//  *   blob: Blob,
//  *   filename: string,
//  *   endpointUrl: string,
//  *   token?: string | null,
//  *   as?: "multipart" | "binary",
//  *   fields?: Record<string, string | number | boolean>
//  * }} args
//  */
// const UploadSelfie = async (args) => {
//     const {
//         blob,
//         filename,
//         endpointUrl,
//         token = null,
//         as = "multipart",
//         fields = {},
//     } = args || {};

//     const headers = new Headers();

//     // Si manejas auth por token:
//     if (token) {
//         headers.set("Authorization", `Bearer ${token}`);
//     }
//     // Si usas cookies HttpOnly, no pongas Authorization
//     // y envía credenciales si es cross-site: fetch(..., { credentials: "include" })

//     let response;

//     if (as === "multipart") {
//         // Enviar como multipart/form-data (IFormFile en .NET)
//         const form = new FormData();
//         form.append("file", blob, filename);

//         // Campos extra opcionales
//         Object.entries(fields).forEach(([k, v]) => form.append(k, String(v)));

//         response = await fetch(endpointUrl, {
//             method: "POST",
//             headers, // OJO: NO seteamos Content-Type; el browser lo hace con boundary
//             body: form,
//             // credentials: "include", // si necesitas cookies
//         });
//     } else {
//         // Enviar binario crudo (cuerpo = blob)
//         // Tu backend debe leer directamente el body (Request.Body en .NET)
//         if (!headers.has("Content-Type")) {
//             headers.set("Content-Type", blob.type || "application/octet-stream");
//         }

//         // Campos extra: si los necesitas, mándalos en querystring o encabezados custom
//         // Ejemplo simple: ?userId=123
//         const urlObj = new URL(endpointUrl, window.location.origin);
//         Object.entries(fields).forEach(([k, v]) => {
//             urlObj.searchParams.set(k, String(v));
//         });

//         response = await fetch(urlObj.toString(), {
//             method: "POST",
//             headers,
//             body: blob,
//             // credentials: "include",
//         });
//     }

//     // Manejo de errores HTTP
//     if (!response.ok) {
//         let text = "";

//         try {
//             text = await response.text();
//         } catch {
//             /* ignore */
//         }
//         throw new Error(
//             `Fallo al subir la selfie (${response.status}). ${text || ""}`.trim()
//         );
//     }

//     // Asumimos que la API devuelve JSON
//     try {
//         return await response.json();
//     } catch {
//         return {};
//     }
// }

//export { UploadSelfie };